import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=74a069d4"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=74a069d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports